// export const BaseUrl = "http://192.168.1.72:8000/"
// export const imgUrl = "http://192.168.1.72:8000"
// export const BaseUrl = "https://fotoframe.foxiomlabs.com/"
// export const imgUrl = "https://fotoframe.foxiomlabs.com"

export const BaseUrl = "https://backend.fotoframesuae.com/"
export const imgUrl = "https://backend.fotoframesuae.com"